import { requestToken, requestTokenImage } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/deposit`;

/** Payment proof image URL. Requires auth, so fetch as a blob, not an <img src>. */
export const depositScreenshotUrl = (filename) =>
  filename ? `${API_ROUTE}/screenshot/${filename}` : null;

class DepositServices {
  /** Allowed deposit amounts + live discount terms. */
  async getDepositConfig() {
    try {
      const response = await requestToken.get(`${API_ROUTE}/config`);
      return response;
    } catch (error) {
      console.error("Error in getDepositConfig:", error);
      throw error;
    }
  }

  async getDepositList(page, limit, status, filter, fromDate, toDate) {
    try {
      const response = await requestToken.get(`${API_ROUTE}/list`, {
        page,
        limit,
        status: status || undefined,
        filter: filter || undefined,
        from_date: fromDate || undefined,
        to_date: toDate || undefined,
      });
      return response;
    } catch (error) {
      console.error("Error in getDepositList:", error);
      throw error;
    }
  }

  /**
   * Every row matching the current filters, for export. Pages through the
   * normal list endpoint rather than asking the server for an unbounded
   * result, matching how transaction history exports already work.
   */
  async getDepositListForExport({ status, filter, fromDate, toDate }) {
    const pageSize = 100;
    let page = 1;
    let totalPages = 1;
    const all = [];

    do {
      const res = await requestToken.get(`${API_ROUTE}/list`, {
        page,
        limit: pageSize,
        status: status || undefined,
        filter: filter || undefined,
        from_date: fromDate || undefined,
        to_date: toDate || undefined,
      });
      if (!res?.isSuccess) break;
      all.push(...(res.data || []));
      totalPages = res.pagination?.totalPages || 1;
      page += 1;
      // Hard stop so a runaway dataset cannot hang the browser.
      if (page > 100) break;
    } while (page <= totalPages);

    return all;
  }

  async approveDeposit(id, admin_remark) {
    try {
      const response = await requestToken.post(`${API_ROUTE}/approve`, {
        id,
        admin_remark,
      });
      return response;
    } catch (error) {
      console.error("Error in approveDeposit:", error);
      throw error;
    }
  }

  async rejectDeposit(id, admin_remark) {
    try {
      const response = await requestToken.post(`${API_ROUTE}/reject`, {
        id,
        admin_remark,
      });
      return response;
    } catch (error) {
      console.error("Error in rejectDeposit:", error);
      throw error;
    }
  }

  /** payload must be FormData when a screenshot is attached. */
  async createDeposit(payload) {
    try {
      const response = await requestTokenImage.post(
        `${API_ROUTE}/create`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("Error in createDeposit:", error);
      throw error;
    }
  }
}

export default DepositServices;
